import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isConfiguratorLoading, setIsConfiguratorLoading] = useState(true);

  return (
    <LoadingContext.Provider value={{ isConfiguratorLoading, setIsConfiguratorLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
};
